import {
  Article,
  CalendarToday,
  People,
  Login as LoginIcon,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";
import { Button, Container, useMediaQuery, useTheme } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Banner } from "../Components/Banner";
import { NewsSwiper } from "../Components/NewsSwiper";
import { Session } from "../Components/Session";
import { CalendarSection } from "../Components/CalendarSection";
import { PastorsSwiper } from "../Components/PastorsSwiper";
import { AuthContext } from "../contexts/AuthContext";
import HorizontalCard from "../Components/HorizontalCard";

export const Home = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleAuthAction = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };
  return (
    <>
      <Banner />
      <Session
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
        }}
      >
      </Session>

      <Session
        icon={
          <Article
            sx={{ color: theme.palette.primary.main, fontSize: "1.8rem" }}
          />
        }
        title="Notícias"
      >
        <NewsSwiper />
      </Session>
      <Session
        icon={
          <CalendarToday
            sx={{ color: theme.palette.primary.main, fontSize: "1.8rem" }}
          />
        }
        title="Agenda"
      >
        <CalendarSection />
      </Session>
      <Session
        icon={
          <People
            sx={{ color: theme.palette.primary.main, fontSize: "1.8rem" }}
          />
        }
        title="Nossos Pastores"
      >
        <PastorsSwiper />
      </Session>

      {/* Botão de Acesso */}
      <Container sx={{ py: 4, display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          size="large"
          startIcon={isAuthenticated ? <DashboardIcon /> : <LoginIcon />}
          onClick={handleAuthAction}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: "white",
            padding: isMobile ? "12px 24px" : "16px 32px",
            fontSize: isMobile ? "1rem" : "1.1rem",
            fontWeight: "600",
            borderRadius: "8px",
            textTransform: "uppercase",
            letterSpacing: "1px",
            minWidth: "200px",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {isAuthenticated ? "Acessar Dashboard" : "Acesso Secretaria"}
        </Button>
      </Container>
    </>
  );
};
